<template>
  <el-dialog class="rc-dialog" title="单位考核规则查询" :visible.sync="CUFlag" v-if="CUFlag" @close="closeDialog"
    :close-on-click-modal="false" width="50%">
    <el-form ref="searchForm" class="search-form" size="small" :rules="rules" :model="searchForm" label-position="right"
      label-width="100px">
      <el-form-item label="适用组织：" prop="deptName">
        <popup-tree-input class="w-half" :data="deptTreeList" :props="props" :prop="searchForm.deptName"
          :currentChangeHandle="getMenuID" :loadNode="loadNode" placeholder="请选择适用组织"></popup-tree-input>
      </el-form-item>
      <el-form-item label="生效年份：" prop="effectYear">
        <div style="display: flex;">
          <el-date-picker class="w-half" v-model="searchForm.effectYear" type="year" placeholder="选择年"
            value-format="yyyy">
          </el-date-picker>
          <div class="m-l-20">
            <butn btntype="primary" title="查询" @click.native="search"></butn>
            <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <div class="dept-rule-content">
      <div class="empty-view" v-if="isInit || searchEmpty">
        <div v-if="isInit">请先选择需要查询的单位和生效年份</div>
        <div v-if="searchEmpty">您查询的单位对应生效年份未配置考核规则</div>
      </div>
      <template v-else>
        <div class="content-title">您查询的单位对应生效年份考核规则如下：</div>
        <el-form :model="deptRuleInfo" label-width="100px" label-position="right" size="small">
          <el-form-item label="适用组织：" prop="deptId">
            <el-input class="w-half" v-model="deptRuleInfo.deptName" disabled></el-input>
          </el-form-item>
          <el-form-item label="考核方式：" prop="examType">
            <el-radio-group v-model="deptRuleInfo.examType" v-removeAriaHidden disabled>
              <el-radio :label="1">干部级别</el-radio>
              <el-radio :label="2">管理主体</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="考核要求：">
            <div v-if="deptRuleInfo.details && deptRuleInfo.details.length > 0">
              <div class="require_row" v-for="(item, i) in deptRuleInfo.details" :key="i">
                {{ item.typeName }}，达标学时
                <el-input-number v-model="item.examCredit" :min="0" :precision="0" disabled></el-input-number>
                <el-checkbox class="m-l-12" label="0" v-model="item.isCompulsory" :true-label="1" :false-label="0"
                  disabled>完成平台必修课</el-checkbox>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import { queryDeptRule } from "@/api/examRule";
import { lazyTree } from "@/api/dept";
import PopupTreeInput from "@/components/PopupTreeInput/index";

export default {
  components: { butn, PopupTreeInput },
  data() {
    return {
      deptTreeList: [],
      pickerOptions: {
        disabledDate(time) {
          let n = new Date();
          let y = n.getFullYear();
          return time.getFullYear() < y;
        },
      },
      CUFlag: false,
      rules: {
        deptName: [{ required: true, message: "请选择查询单位", trigger: "change" }],
        effectYear: [{ required: true, message: "请选择生效年份", trigger: "blur,change" }]
      },
      props: {
        label: "name",
        isLeaf: function (data, node) {
          return !data.hasChildren
        },
      },
      searchForm: {},
      deptRuleInfo: {},
      searchLoading: false,
      searchEmpty: false,
      isInit: true
    };
  },
  created() {

  },
  methods: {

    show() {
      this.searchForm = {
        deptId: "",
        deptName: "",
        effectYear: "",
      };
      this.cadreTypeAttr = [];
      this.leaderTypeList = [];
      this.isInit = true;
      this.searchEmpty = false;
      this.initMenuL();
      this.CUFlag = true;
    },
    initMenuL() {
      lazyTree().then((res) => {
        this.deptTreeList = res.data;
      });
    },

    search() {
      this.$refs.searchForm.validate((valid) => {
        if (valid) {
          this.isInit = false;
          let params = {
            deptId: this.searchForm.deptId,
            effectYear: this.searchForm.effectYear,
          };
          
          queryDeptRule(params).then(({ code, data = null }) => {
            if (code === 0 && data && Object.keys(data).length > 0) {
              this.searchEmpty = false;
              this.deptRuleInfo = data;
            } else {
              this.searchEmpty = true;
            }
          }).catch(_ => {
            this.searchEmpty = true;
          });
        }
      });
    },

    resetData() {
      this.searchForm = {
        deptId: "",
        deptName: "",
        effectYear: "",
      };
    },


    closeDialog() {
      // 点击取消 数据重置
      this.CUFlag = false;
    },
    closeFrom() {
      this.CUFlag = false;
    },
    loadNode(node, resolve) {
      // console.log(node);
      if (node.level === 0) {
        return resolve(this.deptTreeList);
      }
      if (node.level >= 1) return this.getChildNode(node, resolve);
    },
    getChildNode(node, resolve) {
      setTimeout(() => {
        lazyTree({
          parentId: node.data.id || "",
        }).then((res) => {
          resolve(res.data);
        });
      }, 300);
    },
    getMenuID(data) {
      if (data.id != this.searchForm.deptId) {
        if (data.deptLevelCode === '001') {
          this.$message.warning('顶级节点无法作为查询条件');
        } else {
          this.searchForm.deptId = data.id;
          this.searchForm.deptName = data.name;
        }

      }
    },
  },
  computed: {
  }
};
</script>

<style scoped lang="scss">
.search-form {
  border-bottom: 1px solid #D7D7D7;
}

.dept-rule-content {
  margin-top: 20px;

  .content-title {
    margin-left: 10px;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 16px;

  }

  .empty-view {
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.m-l-12 {
  margin-left: 12px;
}

.m-l-20 {
  margin-left: 20px;
}

.w-half {
  width: 50%;
}

.require_row {
  padding: 12px 0;
}
</style>
